<template>
  <div class="p-6">
    <div class="surface-card p-4 shadow-sm border rounded-lg">
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-2xl font-bold text-secondary">Postagens do Blog</h2>
        <Button label="Novo Post" icon="pi pi-plus" @click="openNew" class="bg-purple-suit-forced border-none" />
      </div>

      <DataTable :value="postData.content" :rows="postData.perPage" paginator class="p-datatable-sm" :loading="loadingData">
        <Column field="title" header="Título" sortable></Column>
        <Column field="author_name" header="Autor"></Column>
        <Column field="status" header="Status" sortable>
          <template #body="slotProps">
            <Tag :severity="slotProps.data.status == 1 ? 'success' : 'danger'" 
                 :value="slotProps.data.status == 1 ? 'Ativo' : 'Inativo'" />
          </template>
        </Column>
        <Column header="Última atualização" sortable>
          <template #body="slotProps">
            <Tag severity="secondary" :value="slotProps.data.getUpdatedDate()" />
          </template>
        </Column>
        <Column header="Ações">
          <template #body="slotProps">
            <Button icon="pi pi-eye" class="p-button-text p-button-secondary" @click="openPreview(slotProps.data)" />
            <Button icon="pi pi-pencil" class="p-button-text p-button-secondary" @click="editPost(slotProps.data)" />
            <Button icon="pi pi-trash" class="p-button-text p-button-danger" @click="confirmDelete(slotProps.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog v-model:visible="postDialog" header="Salvar Postagem" :modal="true" :style="{ width: '50vw' }">
      <BlogPostForm :postData="selectedPost" @save="onSave" @cancel="postDialog = false" />
    </Dialog>

    <ConfirmationModal 
      v-if="askConfirmation" 
      title="Excluir Postagem" 
      text="Tem certeza que deseja excluir está postagem? Essa ação não pode ser desfeita!" 
      @emitResponse="checkConfirmationResponse" 
    />

    <Dialog v-model:visible="showPostToPreview">
      <BlogPostCardComponent :post="postToPreview" />
    </Dialog>

    <LoadingDialog v-if="performingRemoval" />
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import BlogPostForm from './BlogPostForm.vue';
import { Button, Column, DataTable, Dialog, Tag, useToast } from 'primevue';
import BlogPostService from '@/services/BlogPostService';
import ConfirmationModal from '@/components/Utils/ConfirmationModal.vue';
import LoadingDialog from '@/components/Utils/LoadingDialog.vue';
import { showToast } from '@/composables/toast';
import { translate } from '@/composables/translate';
import BlogPostCardComponent from '@/components/BlogPost/BlogPostCardComponent.vue';
import BlogPostStatus from '@/dictionary/BlogPostStatus';

const toast = useToast();

const postDialog = ref(false);
const selectedPost = ref(null);
const loadingData = ref(true);
const askConfirmation = ref(false);

const showPostToPreview = ref(false);
const postToPreview = ref(null);
const blogPostStatus = new BlogPostStatus();

onMounted(() => {
  loadPosts();
});

const postData = reactive({
  content: [],
  perPage: 10
});
async function loadPosts() {
  loadingData.value = true;
  
  const response = await BlogPostService.get();

  let filtered = [];
  for (let item of response) {
    if (item.status != blogPostStatus.ABOUT_POST) {
      filtered.push(item);
    }
  }

  postData.content = filtered;

  loadingData.value = false;
}

function openPreview(blogPost = null) {
  postToPreview.value = blogPost;
  showPostToPreview.value = true;
}

const openNew = () => {
  selectedPost.value = null;
  postDialog.value = true;
};

const editPost = (post) => {
  selectedPost.value = { ...post };
  postDialog.value = true;
};

const onSave = () => {
  loadPosts();
};

const performingRemoval = ref(false);
const selectedForDeletion = ref(null);
async function confirmDelete(blogPost = null) {
  if (!blogPost && !selectedForDeletion.value) {
    return;
  }

  if (!selectedForDeletion.value) {
    selectedForDeletion.value = blogPost;
    askConfirmation.value = true;
    return;
  }

  performingRemoval.value = true;

  const response = await BlogPostService.remove(selectedForDeletion.value.id);

  performingRemoval.value = false;

  if (!response.success()) {
    showToast(toast, response.getMessage(), 'error');
    return;
  }

  showToast(toast, translate('post removed'));
  loadPosts(true);
}

function checkConfirmationResponse(value){
  if([null,undefined].includes(value)) {
    return;
  }

  const confirmation = value.confirmation;
  askConfirmation.value = false;

  if(confirmation){
    confirmDelete();
  } else {
    selectedForDeletion.value = null;
  }
}
</script>